import classes from "./PPTPollsPage.module.css";
import YuJaButton from "../../components/standardization/YuJaButton";
import {
    ACTIVITY_TYPE_PLACEHOLDER,
    ATTENDANCE,
    EDIT_CONFIGURATION_TEXT,
    EDITING_SYNC_LMS_EMBEDDED_LEARN_MORE,
    EDITING_SYNC_LMS_EMBEDDED_LEARN_MORE_ATTENDANCE,
    GO_BACK_POLLS_LINK,
    INSERT_HEADER,
    LMS_TYPE,
    ONE_MORE_STEP_ATTENDANCE,
    ONE_MORE_STEP_DESCRIPTION_ATTENDANCE,
    ONE_MORE_STEP_DESCRIPTION_POLL,
    ONE_MORE_STEP_POLL,
    POLL_SHARE_MODE,
    POLL_TEXT,
    POLL_TYPE, PPT_INSERT_OPTIONS_DISABLED_EXPLANATION,
    SYNC_LMS_OPTIONS,
    VIEW_ALL_ACTIVITIES_TEXT
} from "../../utils/constants";
import {ReactComponent as RELEASE_ICON} from "../../images/release_options_icon.svg";
import {ReactComponent as INFO_ICON} from "../../images/info_icon.svg"
import {ReactComponent as RELEASE_ENTIRELY_IMAGE} from "../../pages/ReleaseActivityPage/images/release_entriely_image.svg"
import {ReactComponent as RELEASE_BY_QUESTION_IMAGE} from "../../pages/ReleaseActivityPage/images/release_by_question_image.svg"
import React, { useState} from "react";

import {usePPTWebView} from "../../hooks/usePPTWebView";
import {useSynLMSConfiguration} from "../../hooks/useSynLMSConfiguration";
import {PollApiCalls} from "../../apis/PollApiCalls";
import {deCapitalizeWord, notifyError, removePrefix, removePrefixNew} from "../../utils/helpers";
import {ReportApiCalls} from "../../apis/ReportApiCalls";
import {ReactComponent as BACK} from "../../images/arrow-left-purple.svg"
import {LTIApiCalls} from "../../apis/LTIApiCalls";
import {INSERT_SLIDE_FAIL} from "../../utils/toast-message-constants";


export default function PPTInsertOptionsView({reload, selectedPoll,}) {
    const {goEditPage} = usePPTWebView();
    const { checkAppRunning} = ReportApiCalls();
    const {getIntegrationType} = useSynLMSConfiguration();
    const integrationType = getIntegrationType();
    const {updatePollDetails, } = PollApiCalls();
    const {embedActivity} = LTIApiCalls();

    const {pollKey, pollSortKey, pollShareMode,  pollType, syncLmsOption="", lmsHomeUrl="", totalQuestions} = selectedPoll;
    let purePollKey = removePrefix(pollKey);
    let pollCode = removePrefixNew(pollSortKey);

    let shareModeOptionDisabled = pollShareMode !== POLL_SHARE_MODE.UNKNOWN;
    const [shareMode, setShareMode] = useState( pollShareMode !== POLL_SHARE_MODE.UNKNOWN ? pollShareMode : "");

    const [isSubmitting, setIsSubmitting] = useState(false);


    const choosePollShareMode = (pollShareMode) => {
        if (!shareModeOptionDisabled) {
            setShareMode(pollShareMode);
        }
    }

    const onClickLearnMore = () => {
        window.open(LMS_TYPE[integrationType].embeddingLearnMore, '_blank');
    }


    const handleSubmit = async () => {

        setIsSubmitting(true);

        try {
            checkAppRunning(purePollKey, pollCode, shareMode, pollType, totalQuestions).catch(err => {
                console.log(err);
                notifyError(INSERT_SLIDE_FAIL.replaceAll(
                    ACTIVITY_TYPE_PLACEHOLDER,
                    pollType === POLL_TYPE.ATTENDANCE ? ATTENDANCE : POLL_TEXT
                ));
                setIsSubmitting(false);
            });

            if (shareMode === POLL_SHARE_MODE.SHARE_ALL) { // shareAll
                const pollDetails = {};
                pollDetails.pollShareMode = POLL_SHARE_MODE.SHARE_ALL;
                await updatePollDetails(purePollKey, pollCode, pollDetails, true);
                await embedActivity(pollKey, pollCode);
            } else { // shareEach
                if (pollShareMode !== POLL_SHARE_MODE.SHARE_EACH) {//first time
                    await updatePollDetails(purePollKey, pollCode, {pollShareMode: POLL_SHARE_MODE.SHARE_EACH}, true);
                    await embedActivity(pollKey, pollCode);
                }
            }

            // goInsertWaitingPage(pollType);
        } catch (err) {
            console.log(err);
            setIsSubmitting(false);
        }
    }

    if (syncLmsOption === SYNC_LMS_OPTIONS.EMBEDDED && !lmsHomeUrl) {
        return (
            <div className={classes.tableParentContainer}>
                <div
                    className={classes.column}
                    style={{
                        flex: 1,
                        minHeight: 0,
                        width: "100%",
                        maxWidth: "min(1000px, 100%)",
                        padding: 40,
                        gap: 15,
                        alignItems: "center"
                    }}
                >
                    <span style={{flex: 1}}/>
                    <span className={classes.title} style={{fontSize: 20}}>
                        {pollType === POLL_TYPE.ATTENDANCE ? ONE_MORE_STEP_ATTENDANCE : ONE_MORE_STEP_POLL}
                    </span>
                    <span className={classes.description}>
                        {pollType === POLL_TYPE.ATTENDANCE ? ONE_MORE_STEP_DESCRIPTION_ATTENDANCE : ONE_MORE_STEP_DESCRIPTION_POLL}
                        <span className={classes.link} style={{marginLeft: 5}} onClick={onClickLearnMore}>
                            {
                                (pollType === POLL_TYPE.ATTENDANCE
                                    ? EDITING_SYNC_LMS_EMBEDDED_LEARN_MORE_ATTENDANCE
                                    : EDITING_SYNC_LMS_EMBEDDED_LEARN_MORE)
                                + LMS_TYPE[integrationType].name + "."
                            }
                        </span>
                    </span>

                    <img
                        src={LMS_TYPE[integrationType].embedGIF}
                        alt={"How to embed?"}
                        style={{
                            maxWidth: "min(1000px, 100%)",
                            maxHeight: "min(600px, 100%)",
                            marginTop: 20,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            background: "#D9D9D9"
                        }}
                    />

                    <div className={classes.row} style={{marginTop: 30, gap: 10}}>
                        <YuJaButton
                            type={"secondary"}
                            style={{
                                width: 165,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            onClick={() => goEditPage(purePollKey, "configuration")}
                        >
                            {EDIT_CONFIGURATION_TEXT}
                        </YuJaButton>


                        <YuJaButton
                            type={"secondary"}
                            style={{
                                width: 165,
                                height: 35,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                            onClick={reload}
                        >
                            {VIEW_ALL_ACTIVITIES_TEXT}
                        </YuJaButton>
                    </div>
                    <span style={{flex: 2}}/>

                </div>
            </div>
        );
    }

    return (
        <div
            className={classes.tableParentContainer}
            style={{
                position: "relative",
                // overflow: "hidden"
            }}
        >
            <div
                className={classes.column}
                style={{
                    flex: 1,
                    minHeight: 0,
                    width: "100%",
                    overflow: "auto",
                }}
            >
                <span
                    tabIndex={0}
                    style={{
                        cursor: "pointer", display: "flex", alignItems: "center",
                        width: "fit-content", height: 60, padding: 15,
                        outlineOffset: -2,
                    }}
                    onClick={reload}
                >
                    <BACK style={{marginRight: 2}}/>
                    <span>{GO_BACK_POLLS_LINK}</span>
                </span>
                <div style={{flex: 1}}/>
                <div
                    className={classes.column}
                    style={{
                        alignSelf: "center",
                        width: "100%",
                        maxWidth: "min(800px, 100%)",
                        padding: 40,
                    }}
                >

                    <div
                        className={classes.row}
                        style={{
                            alignSelf: "center",
                            gap: 15,
                            marginBottom: 20
                        }}
                    >
                        <span className={classes.plusIconWrapper}><RELEASE_ICON/></span>
                        <span className={classes.title}>
                            {"How would you like your poll questions added to your presentation?"}
                        </span>
                    </div>


                    {shareModeOptionDisabled &&
                        <div className={classes.disabledNotification} style={{marginTop: 20}}>
                            <INFO_ICON className={classes.infoIcon} style={{flexShrink: 0}}/>
                            <span>
                                <span className={classes.title} style={{marginRight: 5}}>
                                    {"Editing Disabled:"}
                                </span>
                                <span>
                                     {PPT_INSERT_OPTIONS_DISABLED_EXPLANATION.replaceAll(
                                         ACTIVITY_TYPE_PLACEHOLDER,
                                         pollType === POLL_TYPE.ATTENDANCE
                                             ? deCapitalizeWord(ATTENDANCE)
                                             : deCapitalizeWord(POLL_TEXT)
                                     )}
                                </span>
                            </span>
                        </div>
                    }

                    <div style={{display: "flex", gap: 40}}>
                        <div
                            tabIndex={shareModeOptionDisabled ? -1 : 0}
                            role={"button"}
                            className={`
                                    ${classes.releaseOptionCard} 
                                    ${shareMode === POLL_SHARE_MODE.SHARE_ALL ? classes.active : ""}
                                    ${shareModeOptionDisabled ? classes.disabled : ""}
                                    `}
                            onClick={() => choosePollShareMode(POLL_SHARE_MODE.SHARE_ALL)}
                        >
                            <RELEASE_ENTIRELY_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                            <span className={classes.title}
                                  style={{textAlign: "center"}}>{"Release All Questions at Once"}</span>
                            <span
                                className={classes.description}
                                style={{textAlign: "center"}}
                            >
                                {"All questions will be inserted on a single slide and can be completed in any order."}
                            </span>
                        </div>

                        <div
                            tabIndex={shareModeOptionDisabled ? -1 : 0}
                            role={"button"}
                            className={`
                                    ${classes.releaseOptionCard} 
                                    ${shareMode === POLL_SHARE_MODE.SHARE_EACH ? classes.active : ""}
                                    ${shareModeOptionDisabled ? classes.disabled : ""}
                                    `}
                            onClick={() => choosePollShareMode(POLL_SHARE_MODE.SHARE_EACH)}
                        >
                            <RELEASE_BY_QUESTION_IMAGE style={{marginBottom: 15, flexShrink: 0}}/>
                            <span className={classes.title}
                                  style={{textAlign: "center"}}>{"Release Questions One at a Time"}</span>
                            <span className={classes.description}
                                  style={{textAlign: "center"}}>
                                {"Questions will be released one at a time as you go through your presentation."}
                            </span>
                        </div>
                    </div>

                </div>

                <div style={{flex: 3}}/>
            </div>


            <div className={classes.footer}>
                <YuJaButton
                    disabled={!shareMode || isSubmitting}
                    style={{padding: "5px 10px", width: 130}}
                    onClick={handleSubmit}
                >
                    {INSERT_HEADER}
                </YuJaButton>
            </div>
        </div>
    );
}